import { FlexAligner } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { responsive } from '@/utils';

import { StyledHeaderControls } from '../cameraStreamWidget.styles.ts';

/** Left header group (name + site badge): the only part of the header allowed to shrink. */
export const StyledHeaderTitle = styled(FlexAligner)`
  padding-left: ${responsive.spacing.small};
  min-width: 0;
  flex: 1 1 auto;
`;

/** Header item (icon or badge) placed in the left header group, next to the pen name. */
export const StyledHeaderItem = styled(StyledHeaderControls)`
  margin-left: ${responsive.spacing.small};
`;
